import { CheckSolid, CheckBorder, Checkbox, styledComponent } from '@hermes/web-components'

export const CheckboxStyled = styledComponent(Checkbox)(() => ({
  margin: 0
}))

export const CheckBorderStyled = styledComponent(CheckBorder)(({ theme }) => ({
  height: '20px',
  width: '20px',
  fill: theme.palette.neutral[200]
}))

export const CheckSolidStyled = styledComponent(CheckSolid)(({ theme }) => ({
  height: '20px',
  width: '20px',
  fill: theme.palette.primary.main
}))
